if (!customElements.get('product-info-tabs')) {
  customElements.define(
    'product-info-tabs',
    class ProductInfoTabs extends customElements.get('tabs-component') {
      constructor() {
        super();

        const baseSetActiveTab = this.setActiveTab.bind(this);
        this.setActiveTab = (tabIndex) => {
          const selectedIndex = Number(tabIndex);
          const { tabPanels } = this.domNodes;

          if (Number.isNaN(selectedIndex) || selectedIndex < 0 || !tabPanels[selectedIndex]) {
            return;
          }

          baseSetActiveTab(selectedIndex);
          this.syncPanels(selectedIndex);
        };
      }

      connectedCallback() {
        this.syncPanels(Number(this.selectedIndex || 0));
      }

      syncPanels(selectedIndex) {
        const { tabPanels } = this.domNodes;
        tabPanels.forEach((panel, index) => {
          panel.hidden = index !== selectedIndex;
        });
      }

      onTabChange() {
        if (!this.selectedTab) return;

        const loadedContent = this.selectedTab.querySelector('.pit__content-inner');
        if (loadedContent) {
          return;
        }

        const template = this.selectedTab.querySelector('template');
        if (!template) {
          return;
        }

        const tabContent = template.content.cloneNode(true);
        this.selectedTab.appendChild(tabContent);
      }

      transition(fromPanel, toPanel) {
        if (fromPanel) {
          fromPanel.hidden = true;
        }

        if (toPanel) {
          toPanel.hidden = false;
        }
      }
    }
  );
}